import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { FormExplorer as BasicHealthFormExplorer } from "src/modules/basic-health";
import { FormExplorer as HtxFormExplorer } from "src/modules/htx";
import { FormExplorer as KdFormExplorer } from "src/modules/kd";
import { FormExplorer as KtxFormExplorer } from "src/modules/ktx";
import { FormExplorer as LtxFormExplorer } from "src/modules/ltx";

export const FormExplorer: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxFormExplorer />;
	}
	if (mod === "ktx") {
		return <KtxFormExplorer />;
	}
	if (mod === "kd") {
		return <KdFormExplorer />;
	}
	if (mod === "basic_health") {
		return <BasicHealthFormExplorer />;
	}
	if (mod === "ltx") {
		return <LtxFormExplorer />;
	}
	return null;
};
